<template>
  <v-dialog v-model="open" persistent max-width="640px">
    <v-card>
      <form @submit.prevent="!isProcessing ? onSubmit() : null">
        <v-card-title><span class="headline">Dodawanie karnetu</span></v-card-title>
        <v-card-text>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                    label="Nr karnetu"
                    v-validate="'required'"
                    v-model="formData.ticket_number"
                    data-vv-name="nr karnetu"
                    :error-messages="errors.collect('nr karnetu')"
                    browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    label="Imię i nazwisko"
                    v-validate="'required'"
                    v-model="formData.ticket_person"
                    data-vv-name="imię i nazwisko"
                    :error-messages="errors.collect('imię i nazwisko')"
                    browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    label="Numer faktury/paragonu"
                    v-model="formData.invoice_number"
                    browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    label="Wartość"
                    v-validate="'required'"
                    type="number"
                    step="0.01"
                    v-model="formData.price"
                    data-vv-name="wartość"
                    :error-messages="errors.collect('wartość')"
                    browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                    label="Pokaż cenę karnetu"
                    v-model="formData.show_price"
                    browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                    label="Faktura do karnetu"
                    v-model="formData.has_invoice"
                    browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                    label="Ze strony internetowej"
                    v-model="formData.from_internet"
                    @change="onChangeFromInternet"
                    browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                    label="Zablokuj karnet"
                    v-model="formData.locked"
                    browser-autocomplete="off">
                </v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    v-if="formData.from_internet"
                    label="Numer z internetu"
                    v-validate="'required'"
                    v-model="formData.from_internet_number"
                    data-vv-name="Numer z internetu"
                    :error-messages="errors.collect('numer z internetu')"
                    browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                    :close-on-content-click="false"
                    v-model="addTicketDatePicker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <v-text-field
                      label="Data wydania"
                      v-validate="'required'"
                      slot="activator"
                      v-model="formData.created"
                      data-vv-name="data wydania"
                      :error-messages="errors.collect('data wydania')"
                      readonly
                      browser-autocomplete="off">
                  </v-text-field>
                  <v-date-picker v-validate="'required'"
                                 v-model="formData.created"
                                 data-vv-name="data wygaśnięcia"
                                 :error-messages="errors.collect('data wydania')"
                                 @input="addTicketDatePicker = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                    :close-on-content-click="false"
                    v-model="addTicketExpirationDatePicker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <v-text-field
                      label="Data ważności"
                      v-validate="'required'"
                      slot="activator"
                      v-model="formData.expiration_date"
                      data-vv-name="data ważności"
                      :error-messages="errors.collect('data ważności')"
                      readonly
                      browser-autocomplete="off">
                  </v-text-field>
                  <v-date-picker v-validate="'required'"
                                 v-model="formData.expiration_date"
                                 data-vv-name="data ważności"
                                 :error-messages="errors.collect('data ważności')"
                                 @input="addTicketExpirationDatePicker = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                    label="Opis usługi"
                    box
                    text-area
                    v-validate="'max:255'"
                    counter="255"
                    v-model="formData.description"
                    data-vv-name="opis usługi"
                    :error-messages="errors.collect('opis usługi')"
                    browser-autocomplete="off">
                </v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                    label="Notatka wewnętrzna"
                    box
                    text-area
                    v-model="formData.internal_note"
                    data-vv-name="opis usługi"
                    :error-messages="errors.collect('notatka wewnętrzna')"
                    browser-autocomplete="off">
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$router.push({name: 'Tickets'})">Anuluj</v-btn>
          <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from 'vuex';
import {clearEmptyFields} from '../../helpers/clearEmptyFields';

export default {
  name: 'CreateTicket',
  data() {
    return {
      open: true,
      formData: {
        show_price: true,
        has_invoice: false,
      },
      isProcessing: false,
      addTicketDatePicker: false,
      addTicketExpirationDatePicker: false,
      addTicketDate: new Date().toISOString()
          .substr(0, 10),
    };
  },
  computed: {},
  methods: {
    ...mapActions('TicketStore', ['createTicket']),
    onChangeFromInternet(val) {
      if (!val) {
        this.formData.from_internet_number = '';
      }
    },
    onSubmit() {
      this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              const formData = clearEmptyFields(Object.assign({}, this.formData));
              this.createTicket(formData)
                  .then(() => {
                    this.isProcessing = false;
                    this.formData = {};
                    this.$router.push({name: 'Tickets'});
                  }, () => {
                    this.isProcessing = false;
                  });
            }
          });
    },
  },
};
</script>

<style scoped>

</style>
